const HANDLE_RADIUS = 8;

export {
    HANDLE_RADIUS,
}
